import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import axios from "axios";
import http from "@/axios/http-common";

interface Client {
  ip: string;
  name: string;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "client-system"
})
class ClientSystemStore extends VuexModule {
  client: Client = null;

  @Mutation
  SET_CLIENT(val: Client) {
    this.client = val;
  }

  @Action({ rawError: true })
  async getWhoAmI(): Promise<void> {
    const response = await axios
      .get(`${http.getAPI().replace("/api/v1", "")}/whoami`)
      .then(resp => {
        this.SET_CLIENT(resp.data);
      });
  }
}

export default getModule(ClientSystemStore);
